/**
 * Configuración centralizada de URLs del API
 * Lee las variables de entorno del archivo .env
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const config = {
  // URL base del servidor
  API_URL,
  API_BASE_URL,
  
  // Endpoints específicos
  endpoints: {
    // Autenticación y usuarios
    auth: `${API_BASE_URL}/usuarios`,
    usuarios: `${API_BASE_URL}/usuarios`,
    
    // Socias
    socias: `${API_URL}`,
    tiposSocia: `${API_URL}/tipoSocias`,
    sociasRequisitos: `${API_BASE_URL}/sociasCR`,
    solicitudIngreso: `${API_BASE_URL}/solicitudingreso`,
    
    // Gestión médica
    medicos: `${API_BASE_URL}/medico`,
    especialidades: `${API_BASE_URL}/especialidad`,
    hospitales: `${API_BASE_URL}/hospital`,
    tratamientos: `${API_BASE_URL}/tratamiento`,
    
    // Mentores y profesiones
    mentores: `${API_URL}`,
    profesiones: `${API_URL}`,
    
    // Características y carnets
    caracteristicas: `${API_URL}/caracteristicas`,
    carnets: `${API_BASE_URL}`,
    tallas: `${API_BASE_URL}`,
    
    // Requisitos
    requisitos: `${API_BASE_URL}`,
    
    // Inventario
    inventario: `${API_BASE_URL}/inventario`,
    locations: `${API_BASE_URL}/locations`,
    
    // Reportes
    reportes: `${API_BASE_URL}`
  }
};

export default config;
